// @ts-nocheck
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import styles from "./../contractDetails.module.css";
import { CustomInput } from "../../../components/Custom/Input";
import {
  CustomChip,
  CustomIconButton,
  CustomInfoButton,
} from "../../../components/Custom/CustomIconButton";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { apiRequest } from "../../../services/apiService";
import {
  getUserRoleBeautifully,
  phoneNumberFormat,
} from "../../../utils/methods/formatters";
import _, { debounce } from "lodash";
import { FileUpload } from "./FileUpload";
import { useDispatch } from "react-redux";
import { alertDialogAciton } from "../../../store/actions/auth";
import { Close } from "@mui/icons-material";
import { getUniversalDateTimeFormat } from "../../../utils/methods/universalDateTimeFormat";
import { isUserRole } from "../../../utils/methods/storeFunc";
import { USER_ROLES } from "../../../staticData/userRoles";
import userImage from "../../../assets/images/user.png";
import GreenMail from "../../../assets/svgs/green-mail.svg";
import PinkPhone from "../../../assets/svgs/pink-phone.svg";
import DeleteWhite from "./../../../assets/images/Delete-white.svg";
import WhiteFile from "./../../../assets/svgs/white-file.svg";
import { EquipmentInput } from "../../../components/Custom/EquipmentInput";
import { CustomSwitch } from "../../../components/Custom/Switch";

export const DetailsForm = ({
  setCurrentStep,
  existingData,
  values,
  setValues,
  errors,
  setFieldValue,
  submitForm,
  readOnly,
  status,
  handleChange,
  handleBlur,
  touched,
  handleContractUpload,
  file,
  clearFile,
  showErrors,
  loading,
}) => {
  const searchInit = useMemo(() => {
    return {
      text: "",
      options: [],
      isLoading: false,
    };
  }, []);
  const [search, setSearch] = useState(searchInit);
  const [eventSearch, setEventSearch] = useState(searchInit);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function closeClickHandler() {
    navigate(-1);
  }

  const handleChangeUserRole = (event) => {
    const {
      target: { value },
    } = event;
    setFieldValue(
      "userRoles",
      typeof value === "string" ? value.split(",") : value,
    );
  };

  async function getAllUser() {
    setSearch((prev) => ({ ...prev, isLoading: true }));
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getAllUsers",
      params: {
        search: search?.text,
        limit: 10,
        page: 1,
      },
      isToken: true,
    });

    if (response?.status == 200) {
      setSearch((prev) => ({
        ...prev,
        isLoading: false,
        options: response?.data?.data?.users?.map((item) => {
          if (!item?.fullName) {
            return {
              ...item,
              fullName: `${item?.firstName} ${item?.lastName}`,
            };
          } else {
            return item;
          }
        }),
      }));
    } else if (response?.status !== 200 || error) {
      setSearch((prev) => ({
        ...prev,
        isLoading: false,
      }));
    }
  }

  async function getAllEvents() {
    setEventSearch((prev) => ({ ...prev, isLoading: true }));
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getAllEvents",
      params: {
        eventName: eventSearch?.text,
        topEvents: 10,
      },
      isToken: true,
    });

    if (response?.status == 200) {
      setEventSearch((prev) => ({
        ...prev,
        isLoading: false,
        options: response?.data?.data?.events?.map((item) => ({
          ...item,
          _id: item?.eventId,
        })),
      }));
    } else if (response?.status !== 200 || error) {
      setEventSearch((prev) => ({
        ...prev,
        isLoading: false,
      }));
    }
  }

  useEffect(() => {
    const debounced = debounce(() => {
      getAllUser();
    }, 300);

    debounced();

    return () => {
      debounced.cancel();
    };
  }, [search?.text]);

  useEffect(() => {
    const debounced = debounce(() => {
      getAllEvents();
    }, 300);

    debounced();

    return () => {
      debounced.cancel();
    };
  }, [eventSearch?.text]);

  const roles = ["client", "contractor", "coordinator"];

  const shouldShowAdditionalDocs =
    (!readOnly && !existingData?._id) ||
    (readOnly && values?.attachments?.length > 0);

  const showDropdowns = !status;

  return (
    <>
      <Box className={styles["contract-details"]}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <InputLabel className={styles["mb-1"]}>Contract Name</InputLabel>
            <CustomInput
              name={"contractName"}
              value={values?.contractName}
              onChange={handleChange}
              fullWidth
              placeholder="Contract Name here..."
              onBlur={handleBlur}
              readOnly={readOnly}
            />
            {touched?.contractName && errors?.contractName && (
              <span className={"error b-none"}>{errors?.contractName}</span>
            )}
          </Grid>

          <Grid item xs={12}>
            <InputLabel className={styles["mb-1"]}>Description</InputLabel>
            <OutlinedInput
              sx={{
                color: "white",
                "& fieldset": {
                  borderColor: "white !important",
                  borderRadius: "6px",
                },
              }}
              name={"contractDescription"}
              value={values?.contractDescription}
              onChange={handleChange}
              onBlur={handleBlur}
              rows={4}
              multiline
              fullWidth
              placeholder="Description..."
            />
            {touched?.contractDescription && errors?.contractDescription && (
              <span className={"error b-none"}>
                {errors?.contractDescription}
              </span>
            )}
          </Grid>

          <Grid item xs={12}>
            {file ? (
              <Box className={styles["contract-file"]}>
                <CustomIconButton
                  sx={{
                    backgroundColor: "white",
                    padding: 0,
                    marginRight: "1rem",
                    marginLeft: "auto",
                    "&:hover": {
                      backgroundColor: "white",
                      opacity: "0.8",
                    },
                  }}
                  onClick={clearFile}
                >
                  <Close sx={{ fontSize: "1rem", color: "black" }} />
                </CustomIconButton>
                <Typography
                  sx={{
                    fontSize: "1.1rem",
                    color: getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    }),
                  }}
                >
                  Selected Contract
                </Typography>
                <Box className={styles["one-line"]}>
                  <img alt={"File image"} src={WhiteFile} />
                  <Typography
                    className={`${styles["label"]} ${styles["color-pink"]}`}
                    sx={{
                      fontSize: "0.8rem",
                      cursor: "pointer",
                      userSelect: "none",
                      "&:active": {
                        opacity: "0.8",
                      },
                    }}
                  >
                    {file.name}
                  </Typography>
                </Box>
              </Box>
            ) : (
              <FileUpload
                text={"Upload contract here"}
                acceptedFormats={"PDF only"}
                fileChangeHandler={handleContractUpload}
              />
            )}

            {showErrors && (
              <span className={"error b-none"}>{"Contract is required"}</span>
            )}
          </Grid>

          <Grid item xs={12}>
            <InputLabel className={styles["mb-1"]}>
              Required Documents
            </InputLabel>
            <EquipmentInput
              options={[]}
              name={"requiredDocuments"}
              placeholder={"Enter Required documents with ; separated"}
              readOnly={readOnly}
              values={
                _.isArray(values?.requiredDocuments)
                  ? values?.requiredDocuments
                  : []
              }
              handleBlur={handleBlur}
              biggerInput
              setFieldValue={(value) =>
                setValues((prev) => {
                  return {
                    ...prev,
                    requiredDocuments: value,
                  };
                })
              }
            />

            {touched?.contractDescription && errors?.contractDescription && (
              <span className={"error b-none"}>
                {errors?.contractDescription}
              </span>
            )}
          </Grid>

          {isUserRole(USER_ROLES.ADMIN, USER_ROLES.SUPERADMIN) && (
            <Grid item xs={12}>
              {/* <InputLabel> */}
              {/*   {readOnly || status ? "Contract For" : "Send Contract"} */}
              {/* </InputLabel> */}
              {showDropdowns && (
                <>
                  <InputLabel
                    sx={{
                      position: "relative",
                    }}
                  >
                    Send Contract To User Roles
                  </InputLabel>
                  <div style={{ position: "relative" }}>
                    <Select
                      id="demo-multiple-chip"
                      name="userRoles"
                      multiple
                      fullWidth
                      value={values?.userRoles || []}
                      onChange={handleChangeUserRole}
                      onBlur={handleBlur}
                      sx={{
                        "& .MuiInputBase-root:hover": {
                          borderColor: "white !important",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "white !important",
                        },
                        "& fieldset": {
                          border: "1px solid",
                          borderRadius: "0.5rem",
                          borderColor: getCssVariableHandler({
                            variableName: "--white-rgb",
                          }),
                        },
                        "& fieldset:hover": {
                          border: "1px solid",
                          borderColor: getCssVariableHandler({
                            variableName: "--white-rgb",
                          }),
                        },
                        "& svg": {
                          fill: getCssVariableHandler({
                            variableName: "--white-rgb",
                          }),
                        },
                      }}
                      MenuProps={{
                        sx: {
                          "& .MuiPaper-root": {
                            border: "1px solid",
                            borderColor: getCssVariableHandler({
                              variableName: "--primary-pink-hex",
                            }),
                            borderRadius: "0.5rem",
                          },
                          "& ul": {
                            overflow: "hidden",
                            display: "flex",
                            flexWrap: "wrap",
                          },
                        },
                      }}
                      renderValue={(selected) => (
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 0.5,
                            textTransform: "capitalize",
                          }}
                        >
                          {selected.map((value) => (
                            <CustomChip key={value} label={value} />
                          ))}
                        </Box>
                      )}
                    >
                      {roles.map((name) => (
                        <MenuItem
                          sx={{ textTransform: "capitalize" }}
                          key={name}
                          value={name}
                        >
                          <Checkbox
                            sx={{
                              padding: "0 0.75rem 0 0",
                              color: getCssVariableHandler({
                                variableName: "--white-rgb",
                              }),
                              "&.Mui-checked": {
                                color: getCssVariableHandler({
                                  variableName: "--primary-pink-hex",
                                }),
                                "& svg": {
                                  fill: getCssVariableHandler({
                                    variableName: "--primary-pink-hex",
                                  }),
                                },
                              },
                            }}
                            checked={values?.userRoles?.includes(name)}
                          />
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                    {values?.userRoles?.length === 0 && (
                      <Typography
                        sx={{
                          position: "absolute",
                          left: "14px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          color: "#aaa",
                          fontSize: "1rem",
                        }}
                      >
                        Select roles...
                      </Typography>
                    )}
                  </div>
                </>
              )}

              {showDropdowns && (
                <>
                  <InputLabel>Send Contract To Specific User</InputLabel>
                  <Autocomplete
                    fullWidth
                    placeholder="Search user here..."
                    name={"users"}
                    onblur={handleBlur}
                    value={null}
                    filterOptions={(option) => option}
                    getOptionLabel={(option) => option?.fullName}
                    isOptionEqualToValue={(option, value) =>
                      option?._id === value?.id
                    }
                    options={search?.options}
                    onChange={(_, val) => {
                      setValues((prev) => {
                        if (
                          prev?.users?.find((item) => item?._id === val?._id)
                        ) {
                          dispatch(
                            alertDialogAciton({
                              open: true,
                              title: "Alert",
                              message: "This user is already selected",
                            }),
                          );
                          return prev;
                        } else {
                          return {
                            ...prev,
                            users: [...(prev?.users || []), val],
                          };
                        }
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search users here... "
                        InputLabelProps={{ style: { color: "white" } }}
                        value={search?.text}
                        onChange={(e) =>
                          setSearch((prev) => ({
                            ...prev,
                            text: e?.target?.value,
                          }))
                        }
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            paddingY: "7px !important",
                            "& fieldset": {
                              borderRadius: "8px",
                              borderColor: "white",
                            },
                            "&:hover fieldset, &.Mui-focused fieldset": {
                              borderColor: "white",
                            },
                            color: "white",
                          },
                          "& .MuiInputBase-input": { color: "white" },
                          "& .MuiAutocomplete-popupIndicator": {
                            color: "white",
                          },
                        }}
                      />
                    )}
                    noOptionText={"No Options"}
                    renderOption={(props, option) => (
                      <li {...props} key={option._id}>
                        <Box className={styles["option-container"]}>
                          <img
                            alt={"profile image"}
                            src={option?.profileImage ?? userImage}
                            className={styles["outline-1"]}
                          />
                          <Box className={styles["data-container"]}>
                            <Typography className={styles["name"]}>
                              {option?.fullName}
                              <span className={styles["role"]}>
                                ({getUserRoleBeautifully(option?.userRole)})
                              </span>
                            </Typography>
                            <Box className={styles["small-details"]}>
                              {option?.mobile ? (
                                <Typography className={styles["small-details"]}>
                                  <span className={styles["label"]}>
                                    <img alt={"Phone image"} src={PinkPhone} />
                                  </span>
                                  <span className={styles["text"]}>
                                    {phoneNumberFormat(option?.mobile)}
                                  </span>
                                </Typography>
                              ) : null}

                              {option?.email ? (
                                <Typography className={styles["small-details"]}>
                                  <span className={styles["label"]}>
                                    <img alt={"Mail image"} src={GreenMail} />
                                  </span>
                                  <span className={styles["text"]}>
                                    {option?.email}
                                  </span>
                                </Typography>
                              ) : null}
                            </Box>
                          </Box>
                        </Box>
                      </li>
                    )}
                    PaperComponent={({ children }) => (
                      <Paper
                        sx={{
                          background: "black",
                          outline: "1px sol_id white",
                          borderRadius: "8px",
                          color: "white",
                        }}
                      >
                        {search?.isLoading ? (
                          <Box
                            sx={{
                              padding: "0.5rem",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <CircularProgress size={22} />
                          </Box>
                        ) : search?.options?.length == 0 ? (
                          <Box
                            sx={{
                              padding: "0.5rem",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            No Options Found
                          </Box>
                        ) : (
                          children
                        )}
                      </Paper>
                    )}
                  />
                </>
              )}

              {values?.users?.length > 0 ? (
                <Box
                  className={`${styles["list-container"]} custom-scroll-design`}
                  sx={{
                    border: "none",
                    padding: "0",
                  }}
                >
                  {values?.users?.map((option, i) => {
                    return (
                      <Box
                        key={option?._id || option?.id || i}
                        className={`${styles["option-container"]} ${styles["bg-black"]}`}
                      >
                        <img
                          className={styles["outline-1"]}
                          alt={"profile image"}
                          src={option?.profileImage ?? userImage}
                        />
                        <Box className={styles["data-container"]}>
                          <Typography className={styles["name"]}>
                            {option?.fullName}
                            <span className={styles["role"]}>
                              ({getUserRoleBeautifully(option?.userRole)})
                            </span>
                          </Typography>
                          <Box className={styles["small-details"]}>
                            {option?.mobile ? (
                              <Typography className={styles["small-details"]}>
                                <span className={styles["label"]}>
                                  <img alt={"Phone image"} src={PinkPhone} />
                                </span>
                                <span className={styles["text"]}>
                                  {phoneNumberFormat(option?.mobile)}
                                </span>
                              </Typography>
                            ) : null}

                            {option?.email ? (
                              <Typography className={styles["small-details"]}>
                                <span className={styles["label"]}>
                                  <img alt={"Mail image"} src={GreenMail} />
                                </span>
                                <span className={styles["text"]}>
                                  {option?.email}
                                </span>
                              </Typography>
                            ) : null}
                          </Box>
                        </Box>

                        {!readOnly && !status && (
                          <CustomIconButton
                            sx={{
                              backgroundColor: `#C369A7 !important`,
                              padding: "0.25rem",
                              width: "auto",
                              marginLeft: "auto",
                              borderRadius: "0.25rem",
                              minWidth: "auto",
                              ":hover": {
                                backgroundColor: "#fff",
                              },
                              "& img": {
                                height: "1.5rem",
                                width: "1.5rem",
                              },
                            }}
                            onClick={() => {
                              setValues((prev) => ({
                                ...prev,
                                users: prev?.users?.filter(
                                  (item) => item?._id !== option?._id,
                                ),
                              }));
                            }}
                          >
                            <img src={DeleteWhite} alt={"delete button"} />
                          </CustomIconButton>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              ) : null}
              {errors?.userRolesOrUsers &&
                (touched?.users || touched?.userRoles) && (
                  <span className="error b-none">
                    {errors?.userRolesOrUsers}
                  </span>
                )}
            </Grid>
          )}

          {!readOnly && (
            <Grid item xs={12}>
              <Box className={styles["one-line"]}>
                <Checkbox
                  sx={{
                    padding: "0",
                    color: getCssVariableHandler({
                      variableName: "--white-rgb",
                    }),
                    "&.Mui-checked": {
                      color: getCssVariableHandler({
                        variableName: "--primary-pink-hex",
                      }),
                      "& svg": {
                        fill: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      },
                    },
                  }}
                  checked={values?.isAttachToEvent}
                  onChange={(e) => {
                    const val = e?.target?.checked;
                    setFieldValue("isAttachToEvent", val);
                    if (!val) setFieldValue("eventId", null);
                  }}
                />
                <InputLabel>Attach this Contract to an event?</InputLabel>
              </Box>
            </Grid>
          )}

          {values?.isAttachToEvent ? (
            <Grid item xs={12}>
              <InputLabel>{status ? "Attached Event" : "Add Event"}</InputLabel>
              {!readOnly && (
                <Autocomplete
                  fullWidth
                  value={null}
                  name={"eventId"}
                  onBlur={handleBlur}
                  getOptionLabel={(option) => option.name || ""}
                  filterOptions={(option) => option}
                  isOptionEqualToValue={(option, value) =>
                    option?._id === value?.id
                  }
                  options={eventSearch?.options}
                  onChange={(_, val) => {
                    setFieldValue("eventId", val);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search event here... "
                      InputLabelProps={{ style: { color: "white" } }}
                      value={eventSearch?.text}
                      onChange={(e) =>
                        setEventSearch((prev) => ({
                          ...prev,
                          text: e?.target?.value,
                        }))
                      }
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          paddingY: "7px !important",
                          "& fieldset": {
                            borderRadius: "8px",
                            borderColor: "white",
                          },
                          "&:hover fieldset, &.Mui-focused fieldset": {
                            borderColor: "white",
                          },
                          color: "white",
                        },
                        "& .MuiInputBase-input": { color: "white" },
                        "& .MuiAutocomplete-popupIndicator": { color: "white" },
                      }}
                    />
                  )}
                  noOptionText={"No Options"}
                  renderOption={(props, option) => (
                    <li {...props} key={option._id}>
                      <Box className={styles["option-container"]}>
                        <Box
                          className={`${styles["data-container"]} ${styles["data-event"]}`}
                        >
                          <Typography
                            className={styles["label"]}
                            sx={{
                              justifyContent: "flex-start !important",
                              width: "100%",
                              textAlign: "left",
                            }}
                          >
                            {option?.eventName}
                          </Typography>
                          <Box className={styles["small-details"]}>
                            {option?.eventStart ? (
                              <Typography
                                sx={{
                                  display: "flex",
                                }}
                              >
                                <span
                                  className={`${styles["label"]} ${styles["color-pink"]}`}
                                >
                                  Event Start :
                                </span>{" "}
                                <span className={styles["text"]}>
                                  {getUniversalDateTimeFormat({
                                    dateTime: option?.eventStart,
                                  })}
                                </span>
                              </Typography>
                            ) : null}

                            {option?.eventEnd ? (
                              <Typography sx={{ display: "flex" }}>
                                <span
                                  className={`${styles["label"]} ${styles["color-green"]}`}
                                >
                                  Event End :
                                </span>{" "}
                                <span className={styles["text"]}>
                                  {getUniversalDateTimeFormat({
                                    dateTime: option?.eventEnd,
                                  })}
                                </span>
                              </Typography>
                            ) : null}
                          </Box>
                        </Box>
                      </Box>
                    </li>
                  )}
                  PaperComponent={({ children }) => (
                    <Paper
                      sx={{
                        background: "black",
                        outline: "1px sol_id white",
                        borderRadius: "8px",
                        color: "white",
                      }}
                    >
                      {eventSearch?.isLoading ? (
                        <Box
                          sx={{
                            padding: "0.5rem",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <CircularProgress size={22} />
                        </Box>
                      ) : eventSearch?.options?.length == 0 ? (
                        <Box
                          sx={{
                            padding: "0.5rem",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          No Options Found
                        </Box>
                      ) : (
                        children
                      )}
                    </Paper>
                  )}
                />
              )}
              {values?.eventId ? (
                <Box
                  sx={{
                    alignItems: "flex-start",
                  }}
                  className={styles["list-container"]}
                >
                  <Typography>
                    <span className={styles["label"]}>
                      {values?.eventId?.eventName}
                    </span>
                  </Typography>
                  <Box sx={{ display: "flex", gap: "1rem" }}>
                    <Typography className={styles["small-details"]}>
                      <span className={styles["color-pink"]}>
                        Event Start:{" "}
                      </span>
                      <span className={styles["opacity-75"]}>
                        {getUniversalDateTimeFormat({
                          dateTime: values?.eventId?.eventStart,
                        })}
                      </span>
                    </Typography>
                    <Typography className={styles["small-details"]}>
                      <span className={styles["color-green"]}>Event End: </span>
                      <span className={styles["opacity-75"]}>
                        {getUniversalDateTimeFormat({
                          dateTime: values?.eventId?.eventEnd,
                        })}
                      </span>
                    </Typography>
                  </Box>
                </Box>
              ) : null}
              {errors?.eventId && touched?.eventId && (
                <span className="error b-none">{errors?.eventId}</span>
              )}
            </Grid>
          ) : null}

          <Grid item xs={12}>
            {shouldShowAdditionalDocs && (
              <InputLabel
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "0.25rem",
                  padding: "0.25rem",
                }}
              >
                Additional Documents{" "}
                <CustomInfoButton
                  placement="right"
                  title="Any additional documents to send with contract"
                />
              </InputLabel>
            )}
            {!existingData?._id && (
              <FileUpload
                text={"Upload additional documents here"}
                acceptedFormats={"PNG, JPG, SVG, PDF, EXCEL and Others"}
                fileChangeHandler={(e) => {
                  setValues((prev) => ({
                    ...prev,
                    attachments: [
                      ...(prev?.attachments || []),
                      ...(e?.target?.files || []),
                    ],
                  }));
                }}
              />
            )}

            {values?.attachments?.length > 0 && (
              <Box className={styles["file-name-container"]}>
                {values.attachments.map((file, index) => (
                  <Box key={index} className={styles["file-btn-container"]}>
                    <img alt={"File image"} src={WhiteFile} />
                    <Typography
                      className={`${styles["label"]} ${styles["color-pink"]}`}
                      sx={{
                        fontSize: "0.8rem",
                        cursor: "pointer",
                        userSelect: "none",
                        "&:active": {
                          opacity: "0.8",
                        },
                      }}
                      onClick={() => {
                        const anchor = document.createElement("a");
                        anchor.href = file.url;
                        anchor.download = file.name;
                        anchor.target = "_blank";
                        anchor.click();
                      }}
                    >
                      {file.name}
                    </Typography>
                    {!status && (
                      <CustomIconButton
                        sx={{
                          backgroundColor: "white",
                          padding: 0,
                          "&:hover": {
                            backgroundColor: "white",
                            opacity: "0.8",
                          },
                        }}
                        onClick={() => {
                          const updated = [...values.attachments];
                          updated.splice(index, 1);
                          setFieldValue("attachments", updated);
                        }}
                      >
                        <Close sx={{ fontSize: "1rem", color: "black" }} />
                      </CustomIconButton>
                    )}
                  </Box>
                ))}
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>

      <Box
        className="bottomButton"
        sx={{
          marginY: "2rem",
          justifyContent: "center",
        }}
      >
        <Button className="btnBlack" onClick={closeClickHandler}>
          Close
        </Button>
        <Button
          className="btnPink"
          onClick={() => {
            if (!existingData?._id) {
              submitForm();
            }
          }}
        >
          {loading ? (
            <CircularProgress sx={{ fontSize: "1.5rem" }} />
          ) : (
            "Submit"
          )}
        </Button>
      </Box>

      {/* auto verify */}
      <Box
        sx={{
          width: "100%",
          paddingX: "1rem",
          paddingBottom: "1rem",
        }}
      >
        <Box className={styles["auto-approve-container"]}>
          <InputLabel>Auto approve contract after user submits</InputLabel>
          <CustomSwitch
            onChange={(e) => {
              const val = e?.target?.checked;
              setFieldValue("isAutoVerify", val);
            }}
            checked={values?.isAutoVerify}
          />
        </Box>
      </Box>
    </>
  );
};

DetailsForm.propTypes = {
  setCurrentStep: PropTypes.func,
  setConData: PropTypes.func,
  existingData: PropTypes.object || null,
  readOnly: PropTypes.bool,
  status: PropTypes.string,
  values: PropTypes.object,
  setFieldValue: PropTypes.func,
  submitForm: PropTypes.func,
  setValues: PropTypes.func,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  touched: PropTypes.func,
  handleContractUpload: PropTypes.func,
  clearFile: PropTypes.func,
  file: PropTypes.any,
  showErrors: PropTypes.bool,
  loading: PropTypes.bool,
};